let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("feg87"), load("lnKog")]).then(() => parcelRequire('2mcHd'));